import type { FunctionComponent } from 'react';

import { ANNOUNCEMENT_CONTENT as HORIZON_1_1_CONTENT } from './horizon-1-1/Horizon11Content';
import { ANNOUNCEMENT_CONTENT as HORIZON_1_2_CONTENT } from './horizon-1-2/Horizon12Content';
import type { AnnouncementContentProps } from './types';

export type { AnnouncementContentProps };

const ANNOUNCEMENT_CONTENT: Record<string, FunctionComponent<AnnouncementContentProps>> = {
    ...HORIZON_1_1_CONTENT,
    ...HORIZON_1_2_CONTENT,
};

export const isKnownNotificationType = (notificationType: string): boolean =>
    Object.hasOwn(ANNOUNCEMENT_CONTENT, notificationType);

export const getAnnouncementContent = (
    notificationType: string,
): FunctionComponent<AnnouncementContentProps> | undefined =>
    isKnownNotificationType(notificationType) ? ANNOUNCEMENT_CONTENT[notificationType] : undefined;
